import type { RouteObject } from 'react-router-dom'
import { useRoutes } from 'react-router-dom'
import Layout from '@/components/Layout'
import Home from '@/pages/Home'
import About from '@/pages/About'
import Services from '@/pages/Services'
import Industries from '@/pages/Industries'
import ServiceAreas from '@/pages/ServiceAreas'
import Quote from '@/pages/Quote'
import Contact from '@/pages/Contact'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/about', element: <About /> },
  { path: '/services', element: <Services /> },
  { path: '/industries', element: <Industries /> },
  { path: '/service-areas', element: <ServiceAreas /> },
  { path: '/quote', element: <Quote /> },
  { path: '/contact', element: <Contact /> },
]

function App() {
  const element = useRoutes(routes)
  return <Layout>{element}</Layout>
}

export default App
